
























































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Responsavel} from '@/model/resource/Responsavel'
import {Helper} from 'simpli-web-sdk'
import ModalUpdateExpiringDate from '@/components/modals/ModalUpdateExpiringDate.vue'
import ModalUpdateActive from '@/components/modals/ModalUpdateActive.vue'
import {AuthRequest} from '@/model/request/AuthRequest'

@Component({
  components: {ModalUpdateExpiringDate, ModalUpdateActive},
})
export default class PopoverResponsavel extends Vue {
  @Prop({type: Object, required: true}) responsavel!: Responsavel
  @Prop({type: [String, Number], default: null}) index!: string | number | null

  get name() {
    if (this.index !== null) {
      return `responsavel${this.index}`
    }
    return 'responsavel'
  }

  clickOutside() {
    this.$tip.hideAll()
  }

  hideEvent() {
    this.$emit('hide')
  }

  showEvent() {
    this.$emit('show')
  }

  goToGrupoParceiroPage() {
    Helper.pushByName('editResponsavelGrupoParceiro', this.responsavel.$id)
  }

  goToEditPage() {
    Helper.pushByName('editResponsavel', this.responsavel.$id)
  }

  goToEditGrupoEconomicoPage() {
    Helper.pushByName('editResponsavelGrupoEconomico', this.responsavel.$id)
  }

  goToPersistRespUser() {
    Helper.pushByName('listResponsavelUsuario', this.responsavel.$id)
  }

  async goToPortal(idResponsavel: number) {
    const token = await AuthRequest.getPainelClienteToken(idResponsavel)

    const url = `${process.env.VUE_APP_BASE_PAINEL_CLIENTE_URL}cockpit?t=${token}`
    window.open(url, '_blank')
  }

  async openModalDataVencimento() {
    this.$modal.open('updateExpiringDate', this.responsavel.$id)
  }

  async openModalBlockResponsavel() {
    this.$modal.open('updateActive', this.responsavel.$id)
  }

  async allowResponsavel() {
    await this.responsavel.updateAtivo(true)
    await Helper.success('system.success.persist')
    window.location.reload()
    this.clickOutside()
  }

  getPositionByIndex() {
    const listIndex = 10
    return this.index && this.index >= listIndex ? 'top' : 'bottom'
  }
}
